import { ENV, TENANT_DOMAIN_INDEX } from '../config/envConfig';

export const getBackUrl = (searchParams: URLSearchParams) => {
  return window.location?.pathname + `?${searchParams.toString()}`;
};

export const getBackUrlParamString = (searchParams: URLSearchParams) => {
  const backUrl = window.location?.pathname + `?${searchParams.toString()}`;
  const params = new URLSearchParams({ backUrl });
  const paramString = params.toString();

  return paramString;
};

export const getTenantIdAndBusinessGroupIdFromUrl = () => {
  //!development override
  const url = `${window.location.host}`.replace('www.', '');
  if (url !== 'localhost:3000') {
    if (ENV === 'DEVELOPMENT') {
      let getTenent = url.split('.')[1];
      return { tenantId: getTenent, businessGroupId: getTenent };
    }
    if (ENV === 'PRODUCTION') {
      let getTenent = url.split('.')[0];
      return { tenantId: getTenent, businessGroupId: getTenent };
    }
  }
  const urlParts = url.split('.');
  const tenantIndex = parseInt(TENANT_DOMAIN_INDEX as string);
  let tenantId = urlParts[tenantIndex] || 'rmg';
  let businessGroupId = tenantId || 'rmg'; //! For now
  if (ENV === 'UAT') tenantId = `${tenantId}-uat`;
  if (ENV === 'UAT') businessGroupId = `${businessGroupId}-uat`;
  return { tenantId, businessGroupId };
};
